import { render } from "./OrdersAsCustomerPage.vue?vue&type=template&id=78347216&ts=true"
import script from "./OrdersAsCustomerPage.ts?vue&type=script&lang=ts"
export * from "./OrdersAsCustomerPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__